import OMOPlayLogo from "../../assets/images/omoplay_logo_black.svg";
import {Alert, Button, Stepper} from "omoplay";
import React, {useEffect, useState} from "react";
import OMOSettingsLayout from "../layout/OMOSettingsLayout";
import {getChannelInfo, postAgentRegistration} from "../../api/account/account.api";
import EnterpriseTierForm from "../form/EnterpriseTierForm";
import ProTierForm from "../form/ProTierForm";
import FreeTierForm from "../form/FreeTierForm";
import {useSearchParams} from "react-router-dom";
import ConnectFin from "../../assets/images/connect_setting_fin.svg";
import {useRecoilValue} from "recoil";
import {accountSelector, channelSelector} from "../../store/selector/selector";
import CardBillingForm from "../form/CardBillingForm";

const OMOAgentSettingPage = () => {
    const [step, setStep] = useState(1);
    const [cardId, setCardId] = useState()
    const [selectedTier, setSelectedTier] = useState("PRO");
    const [monthlyPrice, setMonthlyPrice] = useState(50000)
    const [query] = useSearchParams()
    const id = query.get("id");

    const account = useRecoilValue(accountSelector);
    const channel = useRecoilValue(channelSelector)
    const permissions = account?.channels?.find(ch => ch.id === channel)?.permissions.filter(pm => pm.serviceType !== "Owner")

    useEffect(() => {
        getChannelInfo([id]).catch(() => {
            alert("권한이 없습니다.")
            window.location.href = "/"
        })
    }, [])

    useEffect(() => {
        setMonthlyPrice(selectedTier === "PRO" ? 50000 : (selectedTier === "ENTERPRISE" ? 200000 : 0))
    }, [selectedTier])

    return (
        <OMOSettingsLayout title="오모 Agent 신청">
            <div className="items-center">
                <div className="border bg-white p-[32px]" style={{width: "720px", borderRadius: "16px"}}>
                    <div className="mb-10">
                        <div className="mb-8" style={{width: "200px"}}>
                            <img alt="omoplay" src={OMOPlayLogo} />
                        </div>
                    </div>
                    <div>
                        <Stepper
                            listLabel={[]}
                            totalStep={3}
                            stepActive={step}
                        />
                        {
                            step === 1 && (
                                <div className="flex-col gap-4">
                                    <div className="text-gray-900 font-bold text-[26px]">
                                        환영합니다!<br/>
                                        나에게 맞는 AI 메시지 마케팅 자동화 솔루션 단계를 선택하세요
                                    </div>
                                    <div className="flex-col gap-[12px]">
                                        <div className={`pointer border rounded-[8px]${selectedTier === "FREE" ? " border-primary" : ""}`}
                                             onClick={() => setSelectedTier("FREE")}
                                        >
                                            <FreeTierForm />
                                        </div>
                                        <div className={`pointer border rounded-[8px]${selectedTier === "PRO" ? " border-primary" : ""}`}
                                             onClick={() => setSelectedTier("PRO")}
                                        >
                                            <ProTierForm showRecommend={true} />
                                        </div>
                                        <div className={`pointer border rounded-[8px]${selectedTier === "ENTERPRISE" ? " border-primary" : ""}`}
                                             onClick={() => setSelectedTier("ENTERPRISE")}
                                        >
                                            <EnterpriseTierForm />
                                        </div>
                                    </div>
                                    <div className="flex justify-end text-[13px] font-semibold">* 모든 가격은 VAT 포함</div>
                                    <Alert type="warning" title="이용안내" withIcon={true}>
                                        <li className="text-[13px]">최초 결제일을 기준으로 한달 간격으로 자동 결제됩니다</li>
                                        <li className="text-[13px]">해지시 이미 결제된 구독 요금의 환불은 불가하며, 남은 구독 기간동안 구독이 유지됩니다.</li>
                                        <li className="text-[13px]">솔루션 단계별 비교는 비교페이지에서 더 자세한 내용을 확인할 수 있습니다.</li>
                                        <div className="mt-2">
                                            <Button variants="outlined" style={{borderColor: "var(--shape-primary)"}} value={
                                                <div className="text-primary font-bold">솔루션 단계 비교 페이지</div>
                                            } onClick={() => {
                                                window.open("https://omoplay.com/price/")
                                            }} />
                                        </div>
                                    </Alert>
                                    <div className="flex justify-end">
                                        <Button variants="primary" size="large" value="다음"
                                                onClick={() => setStep(2)}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        {
                            step === 2 && (
                                <div>
                                    <div>
                                        <div className="text-gray-900 font-semibold text-lg mb-2">
                                            결제 수단을 입력 해주세요
                                        </div>
                                        <CardBillingForm onSelectedCard={(cardId) => {
                                            setCardId(cardId)
                                        }} />
                                    </div>
                                    <div className="flex justify-end gap-2 mt-[12px]">
                                        <Button variants="default" value="이전"
                                                onClick={() => setStep(1)}
                                        />
                                        <Button variants="primary" size="large" value="다음" disabled={!cardId}
                                                onClick={() => setStep(3)}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        {
                            step === 3 && (
                                <div>
                                    <div className="flex-col gap-[32px]">
                                        <div className="text-gray-900 font-bold text-[28px]">
                                            최고의 파트너 오모 Agent를<br/>
                                            구축할 준비가 완료되었습니다
                                        </div>
                                        <div className="text-gray-900 font-semibold text-[20px]">
                                            바로 사용해 보실 수 있습니다.
                                        </div>
                                        <div>
                                            <img src={ConnectFin} alt="fin" />
                                        </div>
                                        <div>
                                            <Alert title="확인해 주세요." type="warning" withIcon={true}>
                                                <label className="text-[13px]">
                                                    첫달 이용기간은 연동이 완료되는 시점부터 시작됩니다.<br/>
                                                    기타 서비스 이용관련 및 이용 요금에 대한 문의는 톡문의를 통해 문의 해주세요.
                                                </label>
                                            </Alert>
                                        </div>
                                    </div>
                                    <div className="flex justify-end gap-2 mt-[12px]">
                                        <Button variants="default" value="이전"
                                                onClick={() => setStep(2)}
                                        />
                                        <Button variants="primary" size="large" value="완료"
                                                onClick={() => postAgentRegistration(id, cardId, selectedTier).then(({data}) => {
                                                    if (data !== "success") {
                                                        alert(`신청에 실패했습니다.\n사유: ${data}`)
                                                    } else {
                                                        alert("신청이 완료 되었습니다.")
                                                        window.location.href = "/services"
                                                    }
                                                })}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </OMOSettingsLayout>
    );
};
export default OMOAgentSettingPage;
